'use client';
import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import { Menu, X } from 'lucide-react';

export default function PublicNav() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? 'bg-[#F5F0E8]/95 backdrop-blur-md border-b border-[#E8E0D0]'
            : 'bg-transparent'
        }`}
      >
        <div className="max-w-screen-2xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
          <div className="flex items-center gap-2.5">
            <AppLogo size={32} />
            <span className="font-600 text-[#1C1710] tracking-tight text-base" style={{ fontWeight: 600 }}>
              samopoznanie<span className="text-[#C49A6C]">.tv</span>
            </span>
          </div>

          <div className="hidden md:flex items-center gap-8">
            <a href="#videos" className="text-sm text-[#7A7060] hover:text-[#1C1710] transition-colors">Видео</a>
            <a href="#categories" className="text-sm text-[#7A7060] hover:text-[#1C1710] transition-colors">Темы</a>
            <a href="#featured" className="text-sm text-[#7A7060] hover:text-[#1C1710] transition-colors">Начать здесь</a>
            <Link
              href="/membership-landing"
              className="text-sm px-5 py-2 rounded-full border border-[#1C1710] text-[#1C1710] hover:bg-[#1C1710] hover:text-[#F5F0E8] transition-all duration-200"
            >
              Войти в клуб
            </Link>
          </div>

          <button
            className="md:hidden p-2 rounded-lg text-[#1C1710]"
            onClick={() => setMobileOpen(true)}
            aria-label="Open menu"
          >
            <Menu size={22} />
          </button>
        </div>
      </nav>

      {/* Mobile drawer */}
      <div
        className={`fixed inset-0 z-[100] transition-all duration-300 ${
          mobileOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
      >
        <div
          className="absolute inset-0 bg-black/40 backdrop-blur-sm"
          onClick={() => setMobileOpen(false)}
        />
        <div
          className={`absolute right-0 top-0 bottom-0 w-72 bg-[#F5F0E8] transition-transform duration-300 ${
            mobileOpen ? 'translate-x-0' : 'translate-x-full'
          }`}
        >
          <div className="flex items-center justify-between p-6 border-b border-[#E8E0D0]">
            <span className="font-600 text-[#1C1710]" style={{ fontWeight: 600 }}>Меню</span>
            <button onClick={() => setMobileOpen(false)} className="p-1 text-[#7A7060]">
              <X size={20} />
            </button>
          </div>
          <div className="flex flex-col p-6 gap-4">
            <a href="#videos" onClick={() => setMobileOpen(false)} className="text-[#1C1710] text-base py-2">Видео</a>
            <a href="#categories" onClick={() => setMobileOpen(false)} className="text-[#1C1710] text-base py-2">Темы</a>
            <a href="#featured" onClick={() => setMobileOpen(false)} className="text-[#1C1710] text-base py-2">Начать здесь</a>
            <div className="pt-4 border-t border-[#E8E0D0]">
              <Link
                href="/membership-landing"
                className="block text-center py-3 rounded-full bg-[#1C1710] text-[#F5F0E8] text-sm"
                onClick={() => setMobileOpen(false)}
              >
                Войти в клуб
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}